export const colorFromCreated = (created: string) => {
	let color = 'silver';
	if (created) {
		color =
			'#' +
			Number(String(new Date(created).getTime()).split('').reverse().join(''))
				.toString(16)
				.slice(0, 6);
	}
	return color;
};
